import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, Enums, subUnitsOfTime, toArray, toKeyArray } from 'Mri.Web.Common';
import * as React from 'react';
import { BsFolder } from '@react-icons/all-files/bs/BsFolder';
import { Collapse } from 'reactstrap';
import { ProductTypeList } from './ProductTypeList';

export interface IFileSystemsTypeListProps {
    readonly fileSystems: Mri.FileSystems.FileSystem[];
    readonly fileSystemType: Mri.DisplayApi.FileSystemTypes;
    readonly forceOpen: boolean;
}

@autoinject
@observer
export class FileSystemTypeList extends React.Component<IFileSystemsTypeListProps> {
    public render() {
        const collapsed = this.collapsed && !this.props.forceOpen;
        return (
            <>
                <tr className="foldering-system-row">
                    <td colSpan={6}>
                        <a onClick={this.toggleCollapse} className="mx-2">
                            <em> {collapsed ? <BsFolder /> : <BsFolder />} </em>
                            <b>&nbsp; {Enums.toString(Enums.FileSystemType, this.props.fileSystemType)}</b>
                        </a>

                        {this.hasNewItem && <span className="badge bg-primary">New</span>}
                    </td>
                </tr>
                {!collapsed &&
                    toKeyArray(this.fileSystemsByProdType).map(k => (
                        <ProductTypeList
                            key={k}
                            fileSystems={this.fileSystemsByProdType.get(k)!}
                            fileSystemType={this.props.fileSystemType}
                            forceOpen={this.props.forceOpen}
                            productType={k}
                        />
                    ))}
            </>
        );
    }

    @computed
    private get fileSystemsByProdType() {
        const aggregate: Map<number, Mri.FileSystems.FileSystem[]> = new Map<
        Mri.DisplayApi.FileSystemTypes,
        Mri.FileSystems.FileSystem[]
        >();

        this.props.fileSystems.reduce((agg, value) => {
            const key = value.softwareVersion.productType;
            const arr = agg.get(key) ?? [];
            arr.push(value);
            return agg.set(key, arr);
        }, aggregate);

        return aggregate;
    }

    @computed
    private get hasNewItem() {
        if (!this.fileSystemsByProdType) return false;

        return !!toArray(this.fileSystemsByProdType)
            .flat()
            .find(fs => (fs.updated ? fs.updated > subUnitsOfTime(new Date(), 48, 'hours') : false));
    }

    @bind
    @action
    private toggleCollapse() {
        this.collapsed = !this.collapsed;
    }

    @observable private collapsed = true;
}
